
import { RouteObject } from 'react-router-dom';
import Home from '../pages/home/page';
import Legal from '../pages/legal/page';
import Confidentialite from '../pages/confidentialite/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/mentions-legales',
    element: <Legal />
  },
  {
    path: '/confidentialite',
    element: <Confidentialite />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;